import { call, put, takeLatest } from "redux-saga/effects";
import * as authApis from "../apis/authApis"
import { DEMO_SIGNUP, EMAIL_LOGIN, EMAIL_PASSWORD_LOGIN, EMAIL_SIGNUP, FORGOT_PASSWORD, GOOGLE_AUTH, GOOGLE_LOGIN, RESET_PASSWORD, VERIFY_LOGIN } from "../actions/types";
import { USER_DATA_FAILED, USER_DATA_LOADED } from "../actions/returnType";

export function* googleLoginWorker(action) {
    try {
        const res = yield call(authApis.googleLoginApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
            yield put({ type: USER_DATA_LOADED, data: res?.data?.data?.user });
        } else {
            yield action.onError(res);
            yield put({
                type: USER_DATA_FAILED,
                data: res?.data,
            });
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* googleAuthWorker(action) {
    try {
        const res = yield call(authApis.googleAuthApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
            yield put({ type: USER_DATA_LOADED, data: res?.data?.data?.user });
        } else {
            yield action.onError(res);
            yield put({
                type: USER_DATA_FAILED,
                data: res?.data,
            });
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* emailLoginWorker(action) {
    try {
        const res = yield call(authApis.emailLoginApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
            yield put({ type: USER_DATA_LOADED, data: res?.data?.data?.user });
        } else {
            yield action.onError(res);
            yield put({
                type: USER_DATA_FAILED,
                data: res?.data,
            });
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* emailSignupWorker(action) {
    try {
        const res = yield call(authApis.emailSignUpApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}


export function* forgotPasswordWorker(action) {
    try {
        const res = yield call(authApis.forgotPasswordApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* resetPasswordWorker(action) {
    try {
        const res = yield call(authApis.resetPasswordApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* verifyTokenWorker(action) {
    try {
        const res = yield call(authApis.verifyTokenApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* emailPasswordLoginWorker(action) {
    try {
        const res = yield call(authApis.emailPasswordLoginApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

/**Watcher functions */

export function* googleLoginWorkerWatcher() {
    yield takeLatest(GOOGLE_LOGIN, googleLoginWorker);
}

export function* googleAuthWorkerWatcher() {
    yield takeLatest(GOOGLE_AUTH, googleAuthWorker);
}

export function* emailLoginWorkerWatcher() {
    yield takeLatest(EMAIL_LOGIN, emailLoginWorker);
}

export function* emailSignupWorkerWatcher() {
    yield takeLatest(EMAIL_SIGNUP, emailSignupWorker);
}

export function* forgotPasswordWorkerWatcher() {
    yield takeLatest(FORGOT_PASSWORD, forgotPasswordWorker);
}

export function* resetPasswordWorkerWatcher() {
    yield takeLatest(RESET_PASSWORD, resetPasswordWorker);
}

export function* verifyTokenWatcher() {
    yield takeLatest(VERIFY_LOGIN, verifyTokenWorker);
}

export function* emailPasswordLoginWatcher() {
    yield takeLatest(EMAIL_PASSWORD_LOGIN, emailPasswordLoginWorker);
}